import React from 'react';
import PropTypes from 'prop-types';
import { DisplayButton } from '@xo-union/tk-ui-links';
import UserStore from '~/glm/models/user-store';
import GdsInvitationModel from '~/glm/models/gds/gds-invitation-model';
import { observer, inject } from 'mobx-react';
import styles from './rsvp-details-cell.scss';

@inject('userStore')
@observer
class RsvpDetailsCell extends React.Component {
  static propTypes = {
    userStore: PropTypes.instanceOf(UserStore).isRequired,
    invitations: PropTypes.arrayOf(PropTypes.instanceOf(GdsInvitationModel)).isRequired,
    onClick: PropTypes.func.isRequired,
  };

  goToRsvpFrontend(guestId) {
    const { userStore } = this.props;

    window.open(`/us/${userStore.wedding.slug}/rsvp?gid=${guestId}`, '_blank');
  }

  handleInteraction = openInvitation => {
    if (openInvitation) {
      this.goToRsvpFrontend(openInvitation.guestId);
    } else {
      this.props.onClick();
    }
  };

  render() {
    const { invitations } = this.props;
    const openInvitation = invitations.find(invitation => invitation.displayRsvp === 'Invited');
    const linkCopy = openInvitation ? 'RSVP for Household' : 'View RSVP Responses';

    return (
      <td className={styles.rsvpCell}>
        <DisplayButton
          color="primary"
          className={styles.rsvpCopy}
          onClick={() => this.handleInteraction(openInvitation)}
          onKeyDown={e => (e.key === 'Enter' ? this.handleInteraction(openInvitation) : null)}
        >
          {linkCopy}
        </DisplayButton>
      </td>
    );
  }
}

export default RsvpDetailsCell;
